export default __webpack_public_path__ + "static/banner-img3-7f45818baf73b0f9763df32220e414f7.png";